<template>
  <b-form-group
    :class="inputClass"
    :label="inputLabel"
    :label-for="inputId"
    class="col-md-6 mb-0">
    <div>
      <b-form-input
        :id="inputId"
        v-model="inputValue"
        :disabled="disabled"
        :placeholder="placeholder"
        :required="required"
        :tabindex="tabIndex"
        autocomplete="off"
        type="text"
        @input="onChange();"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @click="onClick()"
      />
      <ul v-show="isOpen" id="autocomplete-elements" class="autocomplete-elements">
        <li v-for="(element, i) in elements" :key="i" :class="{ 'is-active': i === arrowCounter }"
            class="autocomplete-element" @click="setElement(element)">
          {{ element.number + ' - '}} <span v-html="element.formattedTitle"></span>
        </li>
      </ul>
    </div>
  </b-form-group>
</template>

<script>

export default {
  name: 'AutocompleteField',

  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    inputId: {
      type: String,
      required: true
    },
    inputLabel: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    inputClass: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    tabIndex: {
      type: Number,
      required: false
    }
  },

  data () {
    return {
      isOpen: false,
      elements: [...this.items],
      arrowCounter: -1,
      searchInput: { id: null, title: '', number: null},
      inputValue: ''
    }
  },

  watch: {
    inputValue (newValue) {
      this.filterElements()
    }
  },

  mounted () {
    document.addEventListener('click', this.handleClickOutside)
    this.$emit('autocompleteMounted')
  },

  destroyed () {
    document.removeEventListener('click', this.handleClickOutside)
  },

  methods: {
    setElement (element) {
      this.searchInput = { ...element }
      this.inputValue = element.number + ' - ' + element.title
      this.isOpen = false
      this.emitChangeSelectedValue()
      this.emitNewSelectedValue(element)
    },

    filterElements () {
      var searchLower = this.inputValue.toLowerCase()
      if (searchLower === '') {
        searchLower = ' '
      }
      this.elements = this.items
        .filter((item) =>
          item.title.toLowerCase().includes(searchLower) ||
          (item.number && item.number.toString().includes(searchLower))
        )
        .map((item) => {
          let formattedTitle = item.title
          if (item.title.toLowerCase().includes(searchLower)) {
            const matchStart = item.title.toLowerCase().indexOf(searchLower)
            const matchEnd = matchStart + searchLower.length
            const beforeMatch = item.title.slice(0, matchStart)
            const matchText = item.title.slice(matchStart, matchEnd)
            const afterMatch = item.title.slice(matchEnd)
            formattedTitle = `<span>${beforeMatch}</span><span class="autocomplete-match">${matchText}</span><span>${afterMatch}</span>`
          }
          return { ...item, formattedTitle }
        })
    },

    onClick () {
      this.filterElements()
      this.isOpen = true
    },

    onChange () {
      this.filterElements()
      this.isOpen = true
      this.searchInput = this.inputValue
      this.emitChangeSelectedValue()
    },

    handleClickOutside (event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
        this.arrowCounter = -1
        this.emitChangeSelectedValue()
      }
    },

    onArrowDown () {
      if (this.arrowCounter < this.elements.length) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp () {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter () {
      if (this.arrowCounter !== -1) {
        this.searchInput = this.elements[this.arrowCounter]
      }
      this.isOpen = false
      this.arrowCounter = -1
      this.emitChangeSelectedValue()
    },

    emitChangeSelectedValue () {
      this.$emit('elementValueChanged', this.searchInput)
      this.elements = [...this.items]
    },

    emitNewSelectedValue (element) {
      this.$emit('newSelectedValue', element)
    },

    reset () {
      this.inputValue = null
      this.searchInput = null
    }
  }
}

</script>

<style>
.autocomplete {
  position: relative;
}

.autocomplete-elements {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  background: var(--main-white);
  position: fixed;
  z-index: 1;
  width: 20%;
  max-height: 250px;
  overflow-y: auto;
}

.autocomplete-element {
  list-style: none;
  text-align: left;
  padding: 4px 10px;
  cursor: pointer;
}

.autocomplete-element.is-active,
.autocomplete-element:hover {
  background-color: var(--main-color-medium);
  color: white;
}
.autocomplete-match {
  color: var(--main-green-light);
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/AutocompleteField.vue